import { getToken } from '@optimus-web/common';
import { TagProps } from './Tag';
import { TagVariant } from './types';

type TagTokenConfig = Record<TagVariant, ReturnType<typeof getToken>>;
type Props = Pick<TagProps, 'variant'>;

export const getVariant = (props: Props) => {
    const variant: TagVariant = props?.variant || 'basicSubtle';

    return { variant };
};

export const getBackgroundColor = (props: Props) => {
    const backgroundColorTokens: TagTokenConfig = {
        tangerine: getToken('legacyTagBackgroundTangerine'),
        mustard: getToken('legacyTagBackgroundMustard'),
        lime: getToken('legacyTagBackgroundLime'),
        lavender: getToken('legacyTagBackgroundLavender'),
        denim: getToken('legacyTagBackgroundDenim'),
        ruby: getToken('legacyTagBackgroundRuby'),
        basicBold: getToken('legacyTagBackgroundBasicBold'),
        basicSubtle: getToken('backgroundAlertBasicSecondary'),
        primary: getToken('legacyTagBackgroundPrimary'),
        info: getToken('backgroundAlertInfoSecondary'),
        success: getToken('backgroundAlertSuccessSecondary'),
        warning: getToken('backgroundAlertWarningSecondary'),
        danger: getToken('backgroundAlertDangerSecondary'),
    };

    const { variant } = getVariant(props);
    return backgroundColorTokens[variant];
};

export const getColor = (props: Props) => {
    const colorTokens: TagTokenConfig = {
        tangerine: getToken('legacyTagTextTangerine'),
        mustard: getToken('legacyTagTextMustard'),
        lime: getToken('legacyTagTextLime'),
        lavender: getToken('legacyTagTextLavender'),
        denim: getToken('legacyTagTextDenim'),
        ruby: getToken('legacyTagTextRuby'),
        basicBold: getToken('legacyTagTextBasicBold'),
        basicSubtle: getToken('textAlertBasic'),
        primary: getToken('legacyTagTextPrimary'),
        info: getToken('textAlertInfo'),
        success: getToken('textAlertSuccess'),
        warning: getToken('textAlertWarning'),
        danger: getToken('textAlertDanger'),
    };

    const { variant } = getVariant(props);
    return colorTokens[variant];
};

export const getBorderColor = (props: Props) => {
    const borderTokens: TagTokenConfig = {
        tangerine: getToken('legacyTagBorderTangerine'),
        mustard: getToken('legacyTagBorderMustard'),
        lime: getToken('legacyTagBorderLime'),
        lavender: getToken('legacyTagBorderLavender'),
        denim: getToken('legacyTagBorderDenim'),
        ruby: getToken('legacyTagBorderRuby'),
        basicBold: getToken('legacyTagBorderBasicBold'),
        basicSubtle: getToken('borderAlertBasic'),
        primary: getToken('legacyTagBorderPrimary'),
        info: getToken('borderAlertInfo'),
        success: getToken('borderAlertSuccess'),
        warning: getToken('borderAlertWarning'),
        danger: getToken('borderAlertDanger'),
    };

    const { variant } = getVariant(props);
    return borderTokens[variant];
};
